import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-out-store",
  "use": "icon-out-store-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-out-store\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 256L223.418182 0h579.490909L1024 256v768H0V256z m272.290909-162.909091L162.909091 256h698.181818l-109.381818-162.909091H272.290909z m274.618182 463.127273l144.290909 141.963636 51.2-51.2L512 418.909091l-232.727273 228.072727 51.2 51.2 144.290909-141.963636V930.909091h72.145455V556.218182z\" p-id=\"4881\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol